import React from 'react';
import Link from 'next/link';
import { paths } from 'src/utils/paths';
import { CalendarIcon } from 'src/client/components/common/icons';

export const AvailableDates = () => {
  return (
    <div className="mx-5">
      <Link href={paths.accounts.availableDates}>
        <div className="flex mx-auto available-link">
          <div className="bg-dark-green flex icon-bg">
            <CalendarIcon />
          </div>
          <div>
            <p className="text-green font-bold text-sm mb-2">働ける日を登録しましょう！</p>
            <p className="text-sm text-light-black">登録した日の求人通知が届きます。</p>
          </div>
        </div>
      </Link>
      <style jsx>{`
        .available-link {
          max-width: 335px;
          padding: 11px 20px;
          border: 1px solid #d8d8d8;
          box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
          border-radius: 10px;
          align-items: center;
        }
        .icon-bg {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          justify-content: center;
          align-items: center;
          margin-right: 16px;
        }
      `}</style>
    </div>
  );
};
